<template>
	<v-app id="magafilio" :dark="$vuetify.dark">
		<header v-if="showMenubar" style="background-color: #2D2F32 !important; transition: none;">
			<div>
				<router-link to="home">
					<img :src="logoPath" alt="Logo Magafilio" class="app-logo-magafilio-img">
				</router-link>

				<div style="display: flex; align-items: center; margin: 0px 15px;">

					<v-btn color="surface" icon @click="toggleTheme" class="button-theme-toggle">
						<v-icon style="margin: auto; color:#40DA99 !important;" size="24" class="material-icons">
							{{ $vuetify.dark ? 'brightness_7' : 'brightness_4' }}
						</v-icon>
					</v-btn>

					<router-link to="">
						<v-menu bottom class="menu-settings" origin="center center" transition="scale-transition">
							<template v-slot:activator="{ on }">
								<v-btn color="surface" icon v-on="on" class="button-list-menu">
									<v-icon style="margin: auto; color:#40DA99 !important;" size="28">reorder</v-icon>
								</v-btn>
							</template>

							<v-list color="surface">

								<v-list-tile class="list-advertisers" :to="'/advertisers'">
									<v-list-tile-avatar>
										<v-icon class="material-icons" size="28" color="purple">add_business</v-icon>
									</v-list-tile-avatar>
									<v-list-tile-title>Novos Anunciantes</v-list-tile-title>
								</v-list-tile>
								<hr>
								<v-list-tile class="list-tools" :to="'/tools'">
									<v-list-tile-avatar style="transform: rotate(-45deg);">
										<v-icon size="28" color="blue">link</v-icon>
									</v-list-tile-avatar>
									<v-list-tile-title>Ferramentas de Link</v-list-tile-title>
								</v-list-tile>
								<hr>
								<v-list-tile class="list-view" :to="'/visits'">
									<v-list-tile-avatar>
										<v-icon size="28" color="yellow">visibility</v-icon>
									</v-list-tile-avatar>
									<v-list-tile-title>Visitas</v-list-tile-title>
								</v-list-tile>
								<hr>
								<v-list-tile class="list-pay" :to="'/commissions'">
									<v-list-tile-avatar>
										<v-icon size="28" color="green">paid</v-icon>
									</v-list-tile-avatar>
									<v-list-tile-title>Pagamentos</v-list-tile-title>
								</v-list-tile>

								<hr>
								<v-list-tile class="list-combined-report" :to="'/combined-report'">
									<v-list-tile-avatar>
										<v-icon class="material-icons" size="28" color="purple">assessment</v-icon>
									</v-list-tile-avatar>
									<v-list-tile-title>Performance</v-list-tile-title>
								</v-list-tile>

								<hr>
								<v-list-tile class="list-configurations" :to="'/settings'">
									<v-list-tile-avatar>
										<v-icon class="material-icons" size="28" color="cyan">settings</v-icon>
									</v-list-tile-avatar>
									<v-list-tile-title>Configurações</v-list-tile-title>
								</v-list-tile>

								<hr>
								<v-list-tile class="list-coupons" :to="'/coupons'">
									<v-list-tile-avatar>
										<v-icon class="material-icons" size="28"
											color="pink">confirmation_number</v-icon>
									</v-list-tile-avatar>
									<v-list-tile-title>Cupons</v-list-tile-title>
								</v-list-tile>

								<hr>
								<v-list-tile class="list-sair" @click="logout">
									<v-list-tile-avatar>
										<v-icon class="material-icons" size="28" color="red">highlight_off</v-icon>
									</v-list-tile-avatar>
									<v-list-tile-title>Desconectar-se</v-list-tile-title>
								</v-list-tile>
							</v-list>
						</v-menu>

					</router-link>
				</div>
			</div>
		</header>
		<main>
			<notifications style="top: 20px;" />
			<v-content>
				<v-container fluid>
					<transition name="fade" mode="out-in">
						<router-view />
					</transition>
				</v-container>
			</v-content>
		</main>
		<footer v-if="showMenubar" class="hidden-md-and-up">
			<div>
				<div class="link">
					<router-link to="tools" class="btn-link">
						<v-icon class="material-icons" size="28" color="blue"
							style="transform: rotate(-45deg)">link</v-icon>
					</router-link>
				</div>
				<div class="store">
					<router-link to="campaigns" class="btn-store">
						<v-icon class="material-icons" size="28">store</v-icon>
					</router-link>
				</div>
				<div class="home">
					<router-link to="home" class="btn-home">
						<v-icon class="material-icons material-icons-outlined" color="orange"
							size="28">local_fire_department</v-icon>
					</router-link>
				</div>
				<div class="dashboard">
					<router-link to="dashboard" class="btn-dashboard">
						<v-icon class="material-icons" color="yellow" size="28">leaderboard</v-icon>
					</router-link>
				</div>
				<div class="commission">
					<router-link to="purchases" class="btn-commission">
						<v-icon class="material-icons" color="green" size="28">paid</v-icon>
					</router-link>
				</div>
				<div class="coupons">
					<router-link to="coupons" class="btn-coupons">
						<v-icon class="material-icons" color="pink" size="28">confirmation_number</v-icon>
					</router-link>
				</div>
			</div>
		</footer>
	</v-app>
</template>

<script>
import { affiliate_api } from '@/api'

export default {
	name: 'App',
	mixins: [affiliate_api],
	data() {
		return {
			drawer: false,
			menubarVersion: 'afiliados',
			showSwitcher: false,
			counter: null,
		}
	},
	computed: {
		logoPath() {
			if (this.$vuetify.dark) {
				// return require('@/assets/magafilio_logo_modo_escuro.png');
				return require('@/assets/magafilio_logo_modo_claro.png')
			} else {
				return require('@/assets/magafilio_logo_modo_claro.png')
			}
		},
		isLoginPage() {
			return this.$route.path.match(/\/.*login/)
		},
		isRegisterPage() {
			return this.$route.path.match(/\/.*register/)
		},
		showMenubar() {
			return !(this.isLoginPage || this.isRegisterPage)
		},
	},
	watch: {
		'$vuetify.dark'(isDark) {
			this.updateHtmlBodyBackground(isDark)
		}
	},
	methods: {
		updateHtmlBodyBackground(isDark) {
			const color = isDark ? '#2D2F32' : '#F5F5F5'
			document.documentElement.style.backgroundColor = color
			document.body.style.backgroundColor = color
		},
		toggleTheme() {
			this.$vuetify.dark = !this.$vuetify.dark
			localStorage.setItem('theme', this.$vuetify.dark ? 'dark' : 'light')
		},
		pressOnButtonOfHelp: async function () {
			if (localStorage.getItem('guide_tour') == 'true') {
				localStorage.setItem('guide_tour', false)
				await this.patch_guide_tour(this.$root.affiliate.magauser, false)
				this.$router.go()
			} else if (localStorage.getItem('guide_tour') == 'false') {
				localStorage.setItem('guide_tour', true)
				await this.patch_guide_tour(this.$root.affiliate.magauser, true)
				this.$router.go()
			}
		},
		logout: function () {
			localStorage.removeItem('mgf_login')
			localStorage.removeItem('mgf_password')
			localStorage.removeItem('guide_tour')
			localStorage.removeItem('magauser')
			localStorage.removeItem('affiliate')
			localStorage.removeItem('advertiserList')
			this.$router.push('/login')
		},
	},
	created: async function () {
		const savedTheme = localStorage.getItem('theme')
		if (savedTheme) {
			this.$vuetify.dark = savedTheme === 'dark'
		} else {
			this.$vuetify.dark = true
		}

		// CORREÇÃO LATERAIS: Garante que a cor certa seja aplicada no load
		this.updateHtmlBodyBackground(this.$vuetify.dark)

		if (!localStorage.mgf_login || !localStorage.mgf_password) {
			return this.isLoginPage ? undefined : this.$router.push('/login')
		}

		try {
			let affRes = await this.get_affiliate(
				localStorage.mgf_login,
				localStorage.mgf_password
			)
			Object.assign(this.$root.affiliate, affRes.data)
			let advRes = await this.get_aff_adv_list(localStorage.mgf_login)
			this.$root.advertiserList = advRes.data
		} catch (err) {
			localStorage.removeItem('mgf_login')
			localStorage.removeItem('mgf_password')
			localStorage.removeItem('guide_tour')
			localStorage.removeItem('magauser')
			return this.isLoginPage ? undefined : this.$router.push('/login')
		}
	},
}
</script>

<style>
* {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
}

.theme--dark.application {
	background: #2D2F32 !important;
}

.theme--light.application {
	background: #F5F5F5 !important;
}

.theme--dark * {
	color: #c6c6c6;
}


.theme--dark #magafilio,
.theme--dark main.v-content {
	background: #2D2F32 !important;
}

body::-webkit-scrollbar {
	width: 8px;
}

body::-webkit-scrollbar-thumb {
	background: #40DA99;
	border-radius: 6px;
	height: 10px;
}

body {
	scrollbar-width: 0px;
}

#magafilio {
	height: 100vh;
	margin: auto;
	display: flex;
	flex-direction: column;
}

#magafilio header {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	z-index: 999;
	/* Aumentado de 1 para 999 para garantir que nada passe por cima */
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 66px;
	min-height: 66px;
	/* Adicione uma transição suave para quando trocar o tema */
	transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

.header-fixo {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	z-index: 999;
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 66px;
	min-height: 66px;
	box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.25);
	/* Sombra padrão */
	transition: background-color 0.3s ease;
}


#magafilio header div {
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex: 1;
	max-width: 100%;
	margin: auto;
}

#magafilio header div a {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	text-decoration: none;
	margin: 0px 15px;
}

#magafilio header div img.app-logo-magafilio-img {
	width: 125px;
}

.theme--dark .button-list-menu,
.theme--dark .button-theme-toggle {
	box-shadow: -2px -2px 4px rgba(74, 74, 74, 0.25), 2px 2px 4px rgba(0, 0, 0, 0.25) !important;
	border-radius: 7px !important;
}

.button-theme-toggle {
	margin-right: 10px !important;
}

.button-list-menu:focus {
	border: 1px solid #40DA99 !important;
}

.v-icon.material-icons.theme--dark.grey--text:hover {
	color: #c6c6c6 !important;
}

#magafilio main {
	flex: 1;
}

.theme--dark #magafilio footer {
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 77px;
	min-height: 77px;
	background: #2D2F32;
	box-shadow: 0px -4px 16px rgba(0, 0, 0, 0.25);
	padding: 0px 20px;
}

#magafilio footer div {
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 1;
	max-width: 100%;
	margin: auto;
}

#magafilio footer div a {
	display: flex;
	align-items: center;
	justify-content: center;
	text-decoration: none;
}

.theme--dark #magafilio footer div div a {
	box-shadow: -2px -2px 1px rgba(74, 74, 74, 0.25), 2px 2px 1px rgba(0, 0, 0, 0.25);
	border-radius: 24px;
	padding: 8px;
}

.btn-link.router-link-exact-active.router-link-active {
	background-color: #5191F2;
}

.btn-link.router-link-exact-active.router-link-active i {
	color: #2D2F32 !important;
}

.btn-store.router-link-exact-active.router-link-active {
	background-color: #AB84EB;
}

.btn-store.router-link-exact-active.router-link-active i {
	color: #2D2F32 !important;
}

.btn-home.router-link-exact-active.router-link-active {
	background-color: #F6851C;
}

.btn-home.router-link-exact-active.router-link-active i {
	color: #2D2F32 !important;
}

.btn-dashboard.router-link-exact-active.router-link-active {
	background-color: #E9EC58;
}

.btn-dashboard.router-link-exact-active.router-link-active i {
	color: #2D2F32 !important;
}

.btn-commission.router-link-exact-active.router-link-active {
	background-color: #6EDD79;
}

.btn-commission.router-link-exact-active.router-link-active i.v-icon.material-icons.material-icons.theme--light {
	color: #2D2F32 !important;
}

a.btn-store i {
	color: #AB84EB !important;
}

/* ... */

.v-menu__content.theme--light.v-menu__content--fixed.menuable__content__active,
.v-menu__content.theme--dark.v-menu__content--fixed.menuable__content__active {
	top: 66px !important;
}

.theme--dark .v-list.theme--light {
	background-color: #2D2F32 !important;
}


.v-list.theme--light div.list-advertisers .primary--text.v-list__tile--active.v-list__tile.v-list__tile--link.theme--light .v-list__tile__avatar .v-avatar i,
.v-list.theme--light div.list-advertisers .primary--text.v-list__tile--active.v-list__tile.v-list__tile--link.theme--light .v-list__tile__title,
.v-list.theme--light div.list-tools .primary--text.v-list__tile--active.v-list__tile.v-list__tile--link.theme--light .v-list__tile__avatar .v-avatar i,
.v-list.theme--light div.list-tools .primary--text.v-list__tile--active.v-list__tile.v-list__tile--link.theme--light .v-list__tile__title,
.v-list.theme--light div.list-view .primary--text.v-list__tile--active.v-list__tile.v-list__tile--link.theme--light .v-list__tile__avatar .v-avatar i,
.v-list.theme--light div.list-view .primary--text.v-list__tile--active.v-list__tile.v-list__tile--link.theme--light .v-list__tile__title,
.v-list.theme--light div.list-pay .primary--text.v-list__tile--active.v-list__tile.v-list__tile--link.theme--light .v-list__tile__avatar .v-avatar i,
.v-list.theme--light div.list-pay .primary--text.v-list__tile--active.v-list__tile.v-list__tile--link.theme--light .v-list__tile__title,
.v-list.theme--light div.list-configurations .primary--text.v-list__tile--active.v-list__tile.v-list__tile--link.theme--light .v-list__tile__avatar .v-avatar i,
.v-list.theme--light div.list-configurations .primary--text.v-list__tile--active.v-list__tile.v-list__tile--link.theme--light .v-list__tile__title,
/* ESTILO ADICIONADO */
.v-list.theme--light div.list-combined-report .primary--text.v-list__tile--active.v-list__tile.v-list__tile--link.theme--light .v-list__tile__avatar .v-avatar i,
.v-list.theme--light div.list-combined-report .primary--text.v-list__tile--active.v-list__tile.v-list__tile--link.theme--light .v-list__tile__title {
	color: #2D2F32 !important;
}

.v-list.theme--light div.list-advertisers .primary--text.v-list__tile--active.v-list__tile.v-list__tile--link.theme--light {
	background: #AB84EB !important;
}

.v-list.theme--light div.list-tools .primary--text.v-list__tile--active.v-list__tile.v-list__tile--link.theme--light {
	background: #5191F2 !important;
}

.v-list.theme--light div.list-view .primary--text.v-list__tile--active.v-list__tile.v-list__tile--link.theme--light {
	background: #E9EC58 !important;
}

.v-list.theme--light div.list-pay .primary--text.v-list__tile--active.v-list__tile.v-list__tile--link.theme--light {
	background: #6EDD79 !important;
}

.v-list.theme--light div.list-configurations .primary--text.v-list__tile--active.v-list__tile.v-list__tile--link.theme--light {
	background: #3AE3EE !important;
}

.v-list.theme--light div.list-combined-report .primary--text.v-list__tile--active.v-list__tile.v-list__tile--link.theme--light {
	background: #E9EC58 !important;
}

/* ... */


.list-advertisers div.v-list__tile__avatar .v-avatar i {
	color: #AB84EB !important;
}

.list-combined-report div.v-list__tile__avatar .v-avatar i {
	color: #AB84EB !important;
}

.v-list {
	padding: 0px;
}

.v-list__tile {
	padding: 0px;
	width: 230px;
}

.v-list__tile__avatar {
	min-width: 42px;
}

.v-input--selection-controls__input {
	margin-right: 0px !important;
}

.v-list__tile {
	width: 100% !important;
}

.v-select-list.v-card.theme--light .v-list__tile__action i,
.v-input__slot .v-select__slot label.v-label.v-label--active.theme--light.primary--text {
	color: #40DA99 !important;
}

.theme--dark .v-menu__content.theme--light.menuable__content__active .white div {
	background: #2D2F32 !important;
}

.theme--light.v-btn:not(.v-btn--icon):not(.v-btn--flat) {
	border: 1px solid #c4c4c4;
}

.v-menu__activator.v-menu__activator--active .v-text-field__slot label,
.v-menu__activator.v-menu__activator--active .v-input__icon.v-input__icon--prepend i,
.v-menu__activator .v-text-field__slot label {
	color: #40DA99 !important;
}

.theme--dark .v-menu__content.theme--light.menuable__content__active .white .v-btn__content {
	color: #64D97E !important;
}

.theme--dark .v-picker.v-card.v-picker--date.theme--light .v-btn__content {
	color: #64D97E !important;
}

.theme--light * {
	color: #212121;
}

/* Fundo claro do app */
.theme--light #magafilio,
.theme--light main.v-content {
	background: #F5F5F5 !important;
}


.theme--light .button-list-menu,
.theme--light .button-theme-toggle {
	box-shadow: -2px -2px 4px rgba(255, 255, 255, 1), 2px 2px 4px rgba(0, 0, 0, 0.1) !important;
}

.theme--light #magafilio footer {
	background: #FFFFFF;
	box-shadow: 0px -4px 16px rgba(0, 0, 0, 0.1);
}

.theme--light #magafilio footer div div a {
	box-shadow: -2px -2px 4px rgba(255, 255, 255, 1), 2px 2px 4px rgba(0, 0, 0, 0.1);
}

/* Corrige o fundo do menu dropdown (modo claro) */
.theme--light .v-list.theme--light {
	background-color: #FFFFFF !important;
}

.theme--light .v-menu__content.theme--light.menuable__content__active .white div {
	background: #FFFFFF !important;
}

.theme--light .v-picker.v-card.v-picker--date.theme--light .v-btn__content {
	color: #40DA99 !important;
}

.theme--light .v-menu__content.theme--light.menuable__content__active .white .v-btn__content {
	color: #40DA99 !important;
}

#magafilio header .v-btn {
	background-color: #2D2F32 !important;
	/* Fundo escuro no botão */
	box-shadow: -2px -2px 4px rgba(74, 74, 74, 0.25), 2px 2px 4px rgba(0, 0, 0, 0.25) !important;
	/* Sombra escura */
	border: none !important;
}

/* Garante que o ícone dentro continue verde/cor definida */
#magafilio header .v-btn .v-icon {
	color: #40DA99 !important;
}

.btn-coupons.router-link-exact-active.router-link-active {
	background-color: #F06292;
}

.btn-coupons.router-link-exact-active.router-link-active i {
	color: #2D2F32 !important;
}

.v-list.theme--light div.list-coupons .primary--text.v-list__tile--active.v-list__tile.v-list__tile--link.theme--light {
	background: #F06292 !important;
}
</style>